module.exports = __webpack_public_path__ + "img/partner_7.f230a28e.png";